module.exports = __webpack_public_path__ + "img/scope3category15.bdaa170d.svg";